// extracted by mini-css-extract-plugin
export var dropdownContainer = "_rf-0";
export var leftAlign = "_rf-4";
export var listItem = "_rf-2";
export var listItemWrapper = "_rf-1";
export var operationText = "_rf-3";